/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { useForceHydration } from './selectors'

const ConditionalHydrate = ({ As = 'span', force = false, children, ...props }) => {
  const isServer = typeof window === 'undefined'
  const forceHydrationHookVal = useForceHydration()
  const forceHydration = force || forceHydrationHookVal

  return (
    <Choose>
      {/* Rendered on the server */}
      <When condition={isServer}>
        <As className={props.className} {...props}>
          {children}
        </As>
      </When>

      {/* Hydrated in the browser */}
      <When condition={forceHydration}>
        <As className={props.className} {...props}>
          {children}
        </As>
      </When>

      {/* NOT hydrated in the browser */}
      <Otherwise>
        <As
          className={props.className}
          dangerouslySetInnerHTML={{ __html: '' }}
          suppressHydrationWarning
          {...props}
        />
      </Otherwise>
    </Choose>
  )
}

export default ConditionalHydrate
